import React, { Component } from 'react';
import lottie from 'lottie-web';

class CountdownTimer extends Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.timeoutInterval = null;
        this.timeout = props.feedbacks && props.feedbacks.timeout && props.feedbacks.timeout.time ? props.feedbacks.timeout.time : 0;
        this.countdown = props.feedbacks && props.feedbacks.countdown ? props.feedbacks.countdown : null;
    }

    /**
     * timeout 倒计时总时间
     * countdown 快结束的动画
     */
    componentDidMount() {
        const that = this;
        let { complateCallback } = this.props;

        if (that.timeout > 0) {
            let timeoutIcon = document.getElementById('timeoutIcon');
            let timeoutText = document.getElementById('timeoutText');
            that.timeoutInterval = setInterval(() => {
                if (timeoutIcon) {
                    if (that.timeout < 0) {
                        if (complateCallback && typeof complateCallback === 'function') {
                            complateCallback();
                        }
                        timeoutIcon.innerHTML = "";
                        clearInterval(that.timeoutInterval);
                        // that.timeout = 0;
                    } else if (that.countdown && that.countdown.time > 0 && that.timeout <= that.countdown.time) {
                        if (that.timeout === that.countdown.time) {
                            if (timeoutIcon) {
                                timeoutIcon.innerHTML = "";
                                try {
                                    let anim = lottie.loadAnimation({
                                        container: timeoutIcon,
                                        renderer: 'svg',
                                        loop: false,
                                        autoplay: true,
                                        path: window.resourceUrl + 'animation/' + that.countdown.resourceID
                                    });
                                    anim.setSubframe(false);
                                    lottie.setQuality('low');
                                } catch (err) { }
                            }
                            let playCountdownAudio = document.getElementById('playCountdownAudio');
                            if (playCountdownAudio) {
                                playCountdownAudio.setAttribute('src', window.resourceUrl + 'audio/' + that.countdown.audio.resourceID);
                            }
                        }
                    } else if (that.timeout < 10) {
                        timeoutText.innerHTML = `<span style="color: red;">${that.timeout}</span>`;
                    } else if (that.timeout >= 0) {
                        timeoutText.innerText = that.timeout;
                    }
                    that.timeout--;
                } else {
                    clearInterval(that.timeoutInterval);
                }
            }, 1000);
        }
    }

    componentWillUnmount() {
        clearInterval(this.timeoutInterval);
    }

    render() {
        const that = this;
        return (
            <div id="countdoenTimeout">
                <span id="timeoutIcon" style={{
                    "position": "absolute",
                    "top": that.countdown && that.countdown.pos ? that.countdown.pos.y * 100 + "%" : "10px",
                    "left": that.countdown && that.countdown.pos ? that.countdown.pos.x * 100 + "%" : "48%",
                    "width": "70px",
                    "height": "47px",
                    "zIndex": 99
                }}>
                    <img alt="" width="25" height="29" src={require("../../static/img/Timer.png")} style={{
                        "position": "absolute",
                        "top": "0",
                        "left": "19px",
                    }} />
                    <span id="timeoutText" style={{
                        "position": "absolute",
                        "top": "5px",
                        "left": "50px",
                        "fontSize": "18px"
                    }}>{Math.max(that.timeout, 0)}</span>
                </span>
                <audio id="playCountdownAudio" className="hide" src="" autoPlay />
            </div>
        );
    }
}

export default CountdownTimer;



// WEBPACK FOOTER //
// ./src/components/on/CountdownTimer.js